import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles'
import {
  lightBlue,
  darkBlue,
} from '@css/constants'

export const PopupHandlerWrapper = styled('div')(css``)

export const PopupTitle = styled('div')(css`
  ${FontNormal(600)};
  ${fontSize(20)};
  text-align: left;
`)

export const PopupContent = styled('div')(css`
  ${FontNormal(400)};
  ${fontSize(16)};
  margin-top: 8px;
  text-align: left;

  & > a {
    ${FontNormal(400)};
    color: ${lightBlue};
    margin-top: 16px;
    transition: all 0.2s ease;
    word-break: break-word;

    &:hover {
      color: ${darkBlue};
    }
  }
`)
